<template>
  <div>
    <v-list>
      <v-list-tile v-for="(list, key) in lists" :key="key">
        <v-list-tile-content @click="viewList(list.id)">
          <v-list-tile-title>{{ list.title }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-menu bottom offset-y>
            <v-btn icon ripple slot="activator">
              <v-icon color="grey lighten-1">more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="showShareDialog(list)">
                <v-list-tile-title>Share</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showEditDialog(list)">
                <v-list-tile-title>Edit</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deleteList(list)">
                <v-list-tile-title>Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile v-for="(list, key) in sharedLists" :key="key + 10000">
        <v-list-tile-content @click="viewList(list.id)">
          <v-list-tile-title>{{ list.title }} <v-icon>people</v-icon></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <br>
    <br>
    <br>

    <v-dialog v-model="dialogModel.newList" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card tile>
        <v-toolbar color="primary">
          <v-btn icon @click.native="dialogModel.newList = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Create List</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click.native="createList">Create</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field name="list-title" label="Title" v-model="listModel.title"></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogModel.share" max-width="500px">
      <v-card>
        <v-card-title>
          Share List
        </v-card-title>
        <v-card-text>
          <v-text-field name="share-email" label="Email" v-model="shareEmail" type="email"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" flat @click.stop="dialogModel.share = false">Close</v-btn>
          <v-btn color="success" flat @click="shareList">Share</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogModel.editList" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card tile>
        <v-toolbar card color="primary">
          <v-btn icon @click.native="dialogModel.editList = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit List</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click.native="editList">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field name="list-title" label="Title" v-model="listModel.title"></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogModel.loading" persistent max-width="200px">
      <v-card>
        <v-card-title style="font-weight: bold; font-size: 20px;">Loading...</v-card-title>
        <v-card-text>
          <v-progress-circular indeterminate color="accent" style="margin: 0 auto; display: block;" size="64"></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-btn color="accent" dark fixed bottom right fab @click.stop="dialogModel.newList = true" :class="mobileFabClass">
      <span class="group pa-2">
        <v-icon>add</v-icon>
      </span>
    </v-btn>
    <!-- <v-btn color="accent" dark fixed bottom right fab @click.stop="dialogModel.newList = true" class="md2-fab" :class="mobileFabClass">
      <span class="group pa-2">
        <v-icon>add</v-icon> New list
      </span>
    </v-btn> -->
  </div>
</template>

<script>
import { firestore, checkAuth } from '../firestoreConnection';
import firebase from 'firebase/app';
import 'firebase/auth';
import axios from 'axios';

export default {
  name: 'my-lists',
  data() {
    return {
      lists: [],
      sharedLists: [],
      dialogModel: {
        newList: false,
        share: false,
        loading: true,
        editList: false
      },
      listModel: {
        title: '',
        id: ''
      },
      shareEmail: '',
      currentSelectedList: undefined
    };
  },
  computed: {
    mobileFabClass: function() {
      return this.$store.state.isMobile ? 'mobileFab' : '';
    }
  },
  created() {
    checkAuth(this)
      .then(function() {
        this.$bind('lists', firestore.collection(`lists`).where('owner', '==', this.$store.state.user.uid));
        this.$bind('sharedLists', firestore.collection(`lists`).where(`sharedWith.${this.$store.state.user.uid}.uid`, '==', this.$store.state.user.uid));

        setTimeout(
          function() {
            if (this.lists == '') {
              this.dialogModel.loading = false;
            }
          }.bind(this),
          3000
        );
      }.bind(this))
      .catch(function() {
        this.$router.push('/login');
      }.bind(this));
  },
  methods: {
    viewList: function(id) {
      this.$router.push(`/list/view/${id}`);
    },
    createList() {
      this.dialogModel.loading = true;

      const key = firestore.collection('lists').doc();
      firestore
        .doc(`lists/${key.id}`)
        .set({
          title: this.listModel.title,
          titleIgnoreCase: this.listModel.title.toUpperCase(),
          owner: this.$store.state.user.uid
        })
        .then(
          function() {
            //todo might not be needed
            // firestore.doc(`users/${this.$store.state.user.uid}/lists/${key.id}`).set({ key: key.id });
            this.dialogModel.newList = false;
            this.listModel.title = '';
            this.dialogModel.loading = false;
          }.bind(this)
        )
        .catch(function(error) {
          alert('Cannot create list');
          console.log(JSON.stringify(error));
          this.dialogModel.loading = false;
        });
    },
    shareList: function() {
      this.dialogModel.loading = true;
      axios
        .post('https://us-central1-smartshoppinglist-6052b.cloudfunctions.net/shareList/execute', {
          email: this.shareEmail,
          listId: this.currentSelectedList.id
        })
        .then(
          function(response) {
            if (response.data.success) {
              this.dialogModel.share = false;
              this.shareEmail = '';
              this.currentSelectedList = undefined;
              this.dialogModel.loading = false;
            } else {
              alert('Email address not found. Invite them to join now!');
              this.dialogModel.share = false;
              this.dialogModel.loading = false;
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            alert('Unknown error, try again later.');
            this.dialogModel.share = false;
            this.dialogModel.loading = false;
            console.log('ERR: ' + JSON.stringify(error));
          }.bind(this)
        );
    },
    deleteList: function(list) {
      let canDelete = confirm(`Delete ${list.title}?`);
      if (canDelete) {
        firestore.doc(`lists/${list.id}`).delete();
      }
    },
    showShareDialog: function(list) {
      this.dialogModel.share = true;
      this.currentSelectedList = list;
    },
    showEditDialog: function(list) {
      this.listModel.title = list.title;
      this.listModel.id = list.id;
      this.dialogModel.editList = true;
    },
    editList: function() {
      this.dialogModel.loading = true;

      firestore.doc(`lists/${this.listModel.id}`).update({
        title: this.listModel.title
      });

      this.listModel.title = '';
      this.listModel.id = '';
      this.dialogModel.editList = false;
      this.dialogModel.loading = false;
    }
  },
  watch: {
    lists: function(val) {
      if (val != [] && val != undefined && val != '') {
        this.dialogModel.loading = false;
      }
    }
  }
};
</script>

<style scoped>
</style>
